import LocationTypeIcon from "@hudson/ui/components/LocationTypeIcon";
import useConfig from "@lib/use_config";

export default function TypeIcon({
  className,
  color,
  type,
  typeKey,
}: {
  className?: string;
  color?: string;
  type?: string;
  typeKey?: string;
}): JSX.Element | null {
  const { data, loading } = useConfig([
    "locationTypeOptions { type image }" as "locationTypeOptions",
  ]);

  return (
    <LocationTypeIcon
      className={className}
      color={color}
      type={type}
      typeKey={typeKey}
      overrides={data?.config.locationTypeOptions}
      loading={loading}
    />
  );
}
